var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastLoading = function SvgFastLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.973 66"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.832 66v-.88c0-5.523.006-11.046-.01-16.569a2.02 2.02 0 0 1 .428-1.293q11.759-15.831 23.5-31.677a2.3 2.3 0 0 0 .366-.638c-.135.109-.279.21-.406.329Q37.113 29.886 21.52 44.507c-.277.26-.49.442-.94.274Q10.54 41.032.48 37.328c-.132-.049-.258-.118-.486-.225L65.973 0c-3.453 19.322-6.878 38.511-10.316 57.757-2.407-.89-4.755-1.756-7.1-2.625-2.454-.909-4.912-1.809-7.357-2.742a.68.68 0 0 0-.91.253q-5.394 6.33-10.818 12.634c-.167.195-.339.386-.637.723"
  })));
};
export default SvgFastLoading;